/**
 * The frontend's own version, kept in sync with `package.json`'s
 * `version` field. Not a backend value - this is the one field on the
 * System/Settings pages that genuinely originates from the frontend
 * itself, displayed as such rather than mislabeled as backend data.
 */
export const FRONTEND_VERSION = "3.1.0-web-platform-foundation";
